'use client';

import Link from 'next/link';
import styles from './not-found.module.css';

export default function NotFound() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
       
        <h1 className={styles.title}>Page Not Found</h1>
        <p className={styles.subtitle}>We couldn’t find what you were looking for.</p>
        <Link href="/" className={styles.button}>
          Back to Home
        </Link>
      </div>
    </div>
  );
}
